/**
 * Rule
 * - use lowercase or lower camelCase
 */

const config={
  global:{
    getApi: '/data/get-global',
  },
  contact:{
    getApi: '/data/get-info',
    setApi: '/api/contacts',
    fields: {
      sub_type: {
        name: 'sub_type',
        label: 'お問合わせ内容を選択してください',
        options: {},
        items: [
          { value:'school',
            label:'お問合わせ',
            icon: 'mail'},
          { value:'visa',
            label:'無料カウンセリング予約',
            icon: 'calendar'}
        ]
      },
      name: {
        name: "name",
        label: "お名前",
        options: {
          rules: [{
            required: true,
            message: 'お名前の入力をお願い致します',
          }],
        }
      },
      email: {
        name: "email",
        label: "Eメールアドレス",
        options: {
          rules: [{
            type: 'email',
            message: '有効なEメールアドレスを入力して下さい',
          }, {
            required: true,
            message: 'Eメールアドレスを入力して下さい',
          }],
        }
      },
      phone: {
        name: "phone",
        label: "お電話番号",
        ph: '半角数字のみ',
        options: {
          rules: [{
            type: "string",
            pattern: /^[\d \-]+$/,
            message: '半角数字でご入力下さい',
          }],
        }
      },
      enquiry: {
        name: "enquiry",
        label: "お問合わせ",
        options: {

        }
      },
      city: {
        name: "city",
        label: "滞在希望都市",
        options: {},
        items: [
          {key: 'sydney', label: 'シドニー'},
          {key: 'melbourne', label: 'メルボルン'},
          {key: 'brisbane', label: 'ブリスベン'},
          {key: 'goldcoast', label: 'ゴールドコースト'},
          {key: 'adelaide', label: 'アデレード'},
          {key: 'perth', label: 'パース'},
        ]
      },
      visa: {
        name: "visa",
        label: "ビザ",
        options: {},
        items: [
          {key: 'wh', label: 'ワーホリ'},
          {key: '2nd-wh', label: 'セカンドワーホリ'},
          {key: 'student', label: '学生ビザ'},
          {key: 'tourist', label: '観光ビザ'},
          {key: 'others', label: 'その他'},
        ]
      },
      visa_expiry: {
        name: "visa_expiry",
        label: "ビザの切れる日",
        options: {},
      },
      school: {
        name: "school",
        label: "学校",
        options: {
        }
      },
      inspection: {
        name: "inspection",
        label: "見学希望日",
        options: {
        }
      },
      counselling_date: {
        name: "counselling_date",
        label: "来店希望日",
        options: {
        }
      },
      counselling_time: {
        name: "counselling_time",
        label: "希望時間",
        options: {},
        items: [
          {key: '10:00', label: '10時〜 (平日のみ)'},
          {key: '11:00', label: '11時〜 (平日/土曜)'},
          {key: '12:00', label: '12時〜 (平日/土曜)'},
          {key: '13:00', label: '13時〜 (平日/土曜)'},
          {key: '14:00', label: '14時〜 (平日/土曜)'},
          {key: '15:00', label: '15時〜 (平日/土曜)'},
          {key: '16:00', label: '16時〜 (平日のみ)'},
          {key: '17:00', label: '17時〜 (平日のみ)'},
        ]
      },
      school_inspection: {
        name: "school_inspection",
        label: "学校見学希望",
        options: {
        }
      },
    }
  },
};

export default config;


// WEBPACK FOOTER //
// ./src/pages/contact/config/config.js